export default "__VITE_ASSET__DfL7pfMU__"